export default __webpack_public_path__ + "static/media/ontraport_logo.802d84d5.png";